import { render, staticRenderFns } from "./peopleUserEdit.vue?vue&type=template&id=2728376a&scoped=true"
import script from "./peopleUserEdit.vue?vue&type=script&lang=js"
export * from "./peopleUserEdit.vue?vue&type=script&lang=js"
import style0 from "./peopleUserEdit.vue?vue&type=style&index=0&id=2728376a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2728376a",
  null
  
)

export default component.exports